// src/components/MetaTagsUpdater.js

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { RoutesConstants } from '../Helper/RoutesConstants';
import { MetaTags } from '../Helper/metaTagsConfig';

const MetaTagsUpdater = () => {
    const location = useLocation();
    const currentPath = location.pathname;

    useEffect(() => {
        const metaTags = MetaTags[currentPath] || MetaTags[RoutesConstants.UNKNOWN];

        document.title = metaTags.title || "Default Title";

        document.querySelector('meta[name="description"]').setAttribute("content", metaTags.description || "Default description");
        document.querySelector('meta[name="keywords"]').setAttribute("content", metaTags.keywords || "default, keywords");
        document.querySelector('meta[name="author"]').setAttribute("content", metaTags.author || "Default Author");

        document.getElementById('meta-title').setAttribute("content", metaTags.og?.title || metaTags.title || "Default Title");
        document.getElementById('meta-description').setAttribute("content", metaTags.og?.description || metaTags.description || "Default description");
        document.getElementById('meta-image').setAttribute("content", metaTags.og?.image || metaTags.imageUrl || "");
        document.getElementById('meta-url').setAttribute("content", metaTags.og?.url || metaTags.url || "");

        document.getElementById('twitter-card').setAttribute("content", metaTags.twitter?.card || "");
        document.getElementById('twitter-title').setAttribute("content", metaTags.twitter?.title || metaTags.title || "Default Title");
        document.getElementById('twitter-description').setAttribute("content", metaTags.twitter?.description || metaTags.description || "Default description");
        document.getElementById('twitter-image').setAttribute("content", metaTags.twitter?.image || metaTags.imageUrl || "");

        document.getElementById('linkedin-title').setAttribute("content", metaTags.linkedin?.title || metaTags.title || "Default Title");
        document.getElementById('linkedin-description').setAttribute("content", metaTags.linkedin?.description || metaTags.description || "Default description");
        document.getElementById('linkedin-image').setAttribute("content", metaTags.linkedin?.image || metaTags.imageUrl || "");
        document.getElementById('linkedin-url').setAttribute("content", metaTags.linkedin?.url || metaTags.url || "");
    }, [currentPath]);

    return null;
};

export default MetaTagsUpdater;
